<div class="app-frame">
  <header class="app-top">
    <button
      type="button"
      class="app-burger"
      [attr.aria-label]="'nav.menu' | translate"
      [attr.aria-expanded]="menuOpen"
      (click)="toggleMenu()"
      >
      <fa-icon icon="bars-staggered"></fa-icon>
    </button>

    <a [routerLink]="routes.accueil" class="app-brand" (click)="closeMenu()">
      <img src="./assets/icon/logo-easyloc.png" alt="" />
      <span class="app-wordmark"><span>Easy</span>Loc</span>
    </a>

    <div class="app-top-actions">
      <button
        type="button"
        id="nav-launcher-desktop"
        class="btn-icon btn-solid"
        [title]="'nav.launcher' | translate"
        [attr.aria-label]="'nav.openLauncher' | translate"
        (click)="openLauncher()"
        >
        <fa-icon icon="table-cells"></fa-icon>
      </button>
      <button
        type="button"
        id="nav-logout-desktop"
        class="btn-icon btn-ghost"
        [title]="'nav.logout' | translate"
        [attr.aria-label]="'nav.logout' | translate"
        (click)="logout()"
        >
        <fa-icon icon="right-from-bracket"></fa-icon>
      </button>
    </div>
  </header>

  <div class="app-body">
    <button
      type="button"
      class="app-scrim"
      [class.is-open]="menuOpen"
      [attr.aria-label]="'nav.closeMenu' | translate"
      [disabled]="!menuOpen"
      (click)="closeMenu()"
    ></button>

    <aside class="app-rail" [class.is-open]="menuOpen">
      <nav [attr.aria-label]="'nav.mainMenu' | translate">
        <a
          [routerLink]="routes.accueil"
          routerLinkActive="is-active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="closeMenu()"
          >
          <fa-icon icon="house"></fa-icon>
          {{ 'nav.home' | translate }}
        </a>
        <a
          [routerLink]="routes.logements"
          routerLinkActive="is-active"
          (click)="closeMenu()"
          >
          <fa-icon icon="house-chimney-window"></fa-icon>
          {{ 'nav.logements' | translate }}
        </a>
        <a
          [routerLink]="routes.contacts"
          routerLinkActive="is-active"
          (click)="closeMenu()"
          >
          <fa-icon icon="house-chimney-user"></fa-icon>
          {{ 'nav.contacts' | translate }}
        </a>
        <a
          [routerLink]="routes.locataires"
          routerLinkActive="is-active"
          (click)="closeMenu()"
          >
          <fa-icon icon="users"></fa-icon>
          {{ 'nav.locataires' | translate }}
        </a>
        <span class="is-soon">
          <fa-icon icon="euro-sign"></fa-icon>
          {{ 'nav.loyers' | translate }}
        </span>
        <span class="is-soon">
          <fa-icon icon="calculator"></fa-icon>
          {{ 'nav.comptabilite' | translate }}
        </span>
      </nav>
    </aside>

    <main class="app-main">
      <ng-content></ng-content>
    </main>
  </div>

  <footer class="app-footer">
    <span class="app-footer-brand"><span>Easy</span>Loc</span>
    <span class="app-footer-meta">{{ 'common.version' | translate:{ version: appVersion } }}</span>
    <span class="app-footer-meta">{{ 'nav.footerRights' | translate:{ year: currentYear } }}</span>
  </footer>

  @if (flashMessage$ | async; as flashMessage) {
    <output
      class="app-flash"
      aria-live="polite"
      >
      <span>{{ flashMessage }}</span>
      <button
        type="button"
        class="app-flash-dismiss"
        [title]="'nav.close' | translate"
        [attr.aria-label]="'nav.close' | translate"
        (click)="dismissFlash()"
        >
        <fa-icon icon="xmark"></fa-icon>
      </button>
    </output>
  }
</div>
